import { required } from 'ra-core';
import { AutocompleteArrayInput } from '../../components/admin/autocomplete-array-input';
import { DateTimeInput } from '../../components/admin/date-time-input';
import { FileInput } from '../../components/admin/file-input';
import { ImageField } from '../../components/admin/image-field';
import { NumberInput } from '../../components/admin/number-input';
import { ReferenceArrayInput } from '../../components/admin/reference-array-input';
import { TextInput } from '../../components/admin/text-input';
import { normalizeDateToISOString } from '../../utils/normalizeDateToISOString';
import { maxFileSize } from '../../utils/validation';
import { SimpleStack } from '../Moonstar/SimpleStack';
import { NudgeAssignmentInput } from './NudgeAssignmentInput';

const imageValidation = maxFileSize('5MB');
const filterByName = (q: string) => ({ name: q });

/**
 * Like the MUI `AutocompleteArrayInput`s (the kit ones have no default): empty lists, so the assignment stays disabled
 * until the nudge is visible to a group. Form-level, because `useWatch` doesn't see the defaults set by the inputs.
 */
export const nudgeFormDefaultValues = { categoryIds: [], userGroupIds: [] };

/**
 * The nudge form inputs, shared by create and edit. Only the create form searched the categories on the server
 * (`searchCategories`), as before.
 */
export const NudgeInputs = ({
  searchCategories = false,
}: {
  searchCategories?: boolean;
}) => (
  <SimpleStack className="sm:w-[400px]">
    <FileInput
      source="image"
      accept={{ 'image/*': ['.jpg', '.jpeg', '.png', '.gif'] }}
      validate={imageValidation}
    >
      <ImageField
        source="src"
        title="title"
        className="[&_img]:max-h-40 [&_img]:object-contain"
      />
    </FileInput>
    <TextInput source="title" validate={required()} />
    <ReferenceArrayInput
      source="categoryIds"
      reference="nudgeCategories"
      perPage={999}
      sort={{ field: 'name', order: 'ASC' }}
    >
      <AutocompleteArrayInput
        optionText="name"
        filterToQuery={searchCategories ? filterByName : undefined}
      />
    </ReferenceArrayInput>
    <ReferenceArrayInput
      source="userGroupIds"
      reference="user-groups"
      perPage={999}
      sort={{ field: 'name', order: 'ASC' }}
    >
      <AutocompleteArrayInput
        optionText="name"
        filterToQuery={filterByName}
        helperText="moonstar.nudges.userGroupIdsHelperText"
      />
    </ReferenceArrayInput>
    <NudgeAssignmentInput />
    <TextInput source="description" />
    <NumberInput source="duration" step={1} min={1} validate={required()} />
    <DateTimeInput
      source="promotedTillDateTime"
      helperText="moonstar.nudges.promotedTillDateTimeHelperText"
      parse={normalizeDateToISOString}
    />
  </SimpleStack>
);
